export default __webpack_public_path__ + "static/media/idaten_kids_logo.4c493726.png";